import axiosClient from "../axiosClient";
import { Abonnement } from "../interfaces/abonnement.interface";

export const findDernierAbonnement = async () => {
  const { data } = await axiosClient.get<Abonnement | null>(
    `/abonnements/dernier-abonnement`
  );
  return data;
};

export const allowReabonnement = async () => {
  const { data } = await axiosClient.get<boolean>(
    `/abonnements/reabonnement-disponible`
  );
  return data;
};

export const findAllAbonnements = async () => {
  const { data } = await axiosClient.get<Abonnement[]>(
    "/abonnements/historique"
  );
  return data;
};
